import EventEmitter from "./utils/EventEmitter";

export default class DynamicDrupalView extends EventEmitter {
    constructor(element) {
        super();

        this.el = element;

        this.fetchView(this.el.dataset.viewName, this.el.dataset.viewDisplayId, this.el.dataset.viewArgs);
    }

    fetchView(viewName, viewDisplayId, viewArgs) {
        // Construction de l'URL pour la requête GET
        const urlParams = new URLSearchParams();
        urlParams.append('view_name', viewName);
        urlParams.append('view_display_id', viewDisplayId);
        urlParams.append('view_args', viewArgs);

        const ajaxUrl = Drupal.url('views/ajax') + '?' + urlParams.toString();


        const fetchOptions = {
            method: 'GET',  // Utilisation de GET ici
            headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest', // Pour indiquer une requête AJAX
            },
        };

        fetch(ajaxUrl, fetchOptions)
          .then((response) => {
              if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.json();
          })
          .then((data) => {
              if (data[3] !== undefined) {
                  const viewHtml = data[3].data;
                  this.el.innerHTML = viewHtml;

                  // Si nécessaire, réactive les comportements Drupal
                  // Drupal.attachBehaviors(this.el, Drupal.settings);
              }
          })
          .catch((error) => {
              console.error('Fetch error:', error);
          });
    }
}
